{
  "privacyPolicy": "Política de privacidad",
  "importantDisclosures": "Divulgaciones importantes (en ingles solamente)",
  "termsOfUse": "Condiciones de uso (en ingles solamente)",
  "yourFinancialGuide": "Su guía de educación financiera",
  "whatWeOffer": "Lo que ofrecemos",
  "ourBusinessOppurtunity": "Nuestra oportunidad de negocio",
  "firstName": "Nombre",
  "lastName": "Apellido",
  "emailAddress": "Dirección de correo electrónico",
  "emailMe": "Envíame un correo electrónico",
  "message": "Mensaje",
  "messagePlaceholder": "Envíe un mensaje a su representante de Primerica",
  "office": "Oficina",
  "mobile": "Móvil",
  "howCanIHelp": "¿Cómo puedo ayudar?",
  "send": "Enviar",
  "scheduleAnAppointment": "Programar una cita",
  "myServices": "Mis servicios",
  "investmentsAndSavings": "Inversiones & ahorros",
  "termLifeInsurance": "Seguro de vida a término",
  "mortgageLoans": "Préstamos hipotecarios",
  "mortgageBranchOffice": "Sucursal de hipotecas",
  "seeImportantDisclosures": "Lea las divulgaciones importantes a continuación",
  "autoHomeOwners": "Programa de referidos de seguro de automóvil y vivienda",
  "primericaBusinessOpportunity": "La oportunidad de negocio de Primerica",
  "aboutMe": "Acerca de mí",
  "pfsInvestmentsRepUS": "Representante registrado de PFS Investments Inc.",
  "pfsInvestmentsRepCN": "Representante de PFSL Investments Canada Ltd., distribuidor de fondos mutuos",
  "lifeInsuranceRep": "Representante de seguro de vida",
  "investmentAdviserRepUS": "Representante asesor de inversiones",
  "investmentAdviserRepCN": "Asesor de Seguridad Financiera Representando a Primerica, una firma en el seguro de personas",
  "enterFirstName": "Ingrese su nombre de pila correctamente",
  "enterLastName": "Ingrese su apellido correctamente",
  "enterEmail": "Ingrese su correo electrónico correctamente",
  "enterMessage": "Introduce tu mensaje",
  "notAvailableInAll": "No disponible en todos los estados/provincias",
  "lifeLicense": "Licencia vitalicia",
  "importantDisclosuresLinkUS": "https://www.primerica.com/public/primerica_disclosures.html",
  "importantDisclosuresLinkCanada": "https://www.primericacanada.ca/public/canada/primerica_disclosures.html",
  "importantDisclosuresLink": "https://www.primerica.com/public/primerica_disclosures.html",
  "importantDisclosuresText": "Divulganciones importantes de Primerica",
  "termsOfUseLinkUS": "https://www.primerica.com/public/terms_conditions.html",
  "termsOfUseLinkCanada": "https://www.primericacanada.ca/public/canada/terms_conditions.html",
  "termsOfUseLink": "https://www.primerica.com/public/terms_conditions.html",
  "termsOfUseText": "Condiciones de uso",
  "privacyPolicyLinkUS": "https://www.primerica.com/public/privacy/online_privacy_policy_sp.html",
  "privacyPolicyLinkCanada": "https://www.primericacanada.ca/public/canada/canada_privacy.html",
  "privacyPolicyLink": "https://www.primerica.com/public/privacy/online_privacy_policy.html",
  "privacyPolicyText": "Política de privacidad"
}
